export const socialLinks = [
	{
		id: 1,
		name: 'Website',
		icon: 'globe',
		url: 'https://jasonsinos.netlify.app/',
	},
	{
		id: 2,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/iasonas-sinos-7887211b3/',
	},
	{
		id: 3,
		name: 'Instagram',
		icon: 'instagram',
		url: 'https://www.instagram.com/iasonas.s/',
	}
];
